"use strict";

var React = require('react'),
    Constants = require('../../constants'),
    ReactRouter = require('react-router'),
    RouteHandler = ReactRouter.RouteHandler,
    BS = require('react-bootstrap'),
    Application = require('../Application'),
    FluxBone = require('../../mixins/FluxBone');

var ToolboxAppWrap = React.createClass({displayName: "ToolboxAppWrap",
    contextTypes: {
        router: React.PropTypes.func
    },

    mixins: [
        FluxBone.ModelMixin('builder', 'sync'),
        FluxBone.ModelMixin('project', 'sync')
    ],

    render: function() {
        return (
            React.createElement(Application, React.__spread({},  this.props, {title: 'NCH - Agent Portal: ' + (this.props.project ? this.props.project.get('name') : '')}))
        );
    }
});

module.exports = ToolboxAppWrap;
